// Sustituto de 'firebase/analytics' (sin seguimiento de Google)
export const getAnalytics = () => ({});
export const logEvent = () => {};
export const setUserId = () => {};
export const setUserProperties = () => {};
export const setAnalyticsCollectionEnabled = () => {};
export const isSupported = async () => false;
